module.exports = __webpack_public_path__ + "files/b3f58c6e846275e3b9b833ebd967c8c0.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-bolditalic-webfont.eot
 ** module id = 399
 ** module chunks = 0
 **/